import React from 'react';
import { Box, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import BaseLayout from './BaseLayout';
import SuccessIcon from './svg/SuccessIcon';
import InfoIcon from './svg/InfoIcon';

const useStyles: any = makeStyles((theme: any) => ({
  mainContent: {
    border: `1px solid ${theme.palette.grey['300']}`,
    borderRadius: 4,
    padding: theme.spacing(4),
  },
  mainContentSuccess: {
    backgroundColor: theme.palette.success.light,
  },
  mainContentInfo: {
    backgroundColor: theme.palette.info['700'],
  },
  pageTitle: {
    margin: theme.spacing(1, 0),
    textAlign: 'center',
  },
  icon: {
    alignSelf: 'auto !important',
  },
}));

enum AlertVariant {
  Success = 'success',
  Info = 'info',
}

interface Props {
  pageTitle: string;
  subtitle?: string;
  variant: AlertVariant[keyof AlertVariant];
  children?: React.ReactNode;
}

const AlertPageLayout = (props: Props) => {
  const classes = useStyles();
  const { pageTitle, subtitle, variant, children } = props;

  return (
    <BaseLayout>
      <main
        className={clsx(classes.mainContent, {
          [classes.mainContentSuccess]: variant === AlertVariant.Success,
          [classes.mainContentInfo]: variant === AlertVariant.Info,
        })}
      >
        <Box display='flex' flexDirection='column' alignItems='center'>
          {variant === AlertVariant.Success && <SuccessIcon className={classes.icon} viewBox='0 0 26 26' />}
          {variant === AlertVariant.Info && <InfoIcon className={classes.icon} />}
          <Typography variant='h3' className={classes.pageTitle} component='p' data-testid='uia-pageTitle'>
            {pageTitle}
          </Typography>
          <Typography variant='body1' component='p' data-testid='uia-subtitle'>
            {subtitle}
          </Typography>
        </Box>
        {children}
      </main>
    </BaseLayout>
  );
};

export default AlertPageLayout;
